import { LegalLayout } from "./Privacy";

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-serif-display text-[color:var(--parchment)] text-2xl md:text-3xl tracking-tight mb-3 constellation-underline">{title}</h2>
    <div className="text-[color:var(--parchment-soft)] font-sans-body leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function Cookies() {
  return (
    <LegalLayout title="Cookie Policy" updated="22 July 2026">
      <Section title="What we use">
        <p>Earth · Pulse uses the smallest number of cookies possible. Right now we set only two categories:</p>
        <div className="rounded-xl border border-[color:var(--gold)]/20 p-5 mt-4" style={{ background: "rgba(19, 27, 54, 0.5)" }}>
          <div className="font-serif-display text-[color:var(--parchment)] text-lg">Strictly necessary</div>
          <ul className="list-disc pl-6 mt-2">
            <li><code>ep-cookies-consent</code> — remembers whether you accepted or declined the banner. Duration: 12 months.</li>
            <li>Stripe cookies during checkout (payment fraud prevention). Set by <a className="text-[color:var(--gold)] underline" href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noreferrer">Stripe</a>.</li>
          </ul>
        </div>
        <div className="rounded-xl border border-[color:var(--gold)]/20 p-5 mt-4" style={{ background: "rgba(19, 27, 54, 0.5)" }}>
          <div className="font-serif-display text-[color:var(--parchment)] text-lg">Analytics / marketing</div>
          <p>None by default. If we ever add these (e.g. Plausible, Meta Pixel for TikTok/IG conversion tracking), they will only load after you tick &quot;Accept&quot; on the banner.</p>
        </div>
      </Section>
      <Section title="Change your choice">
        <p>Clear this site&apos;s data in your browser to reset the banner, or email <a className="text-[color:var(--gold)] underline" href="mailto:privacy@earthpulse.store">privacy@earthpulse.store</a>.</p>
      </Section>
    </LegalLayout>
  );
}
